<template>
	<module class="module-config" title="通知公告配置">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="模块名称" required>
				<c-input name="title"></c-input>
			</c-form-item>
			<c-form-item label="内容" required>
				<c-editor name="content" height="600"></c-editor>
			</c-form-item>
		</c-form>
	</module>
</template>

<script>
	export default {
		data() {
			return {
			}
		},

		methods: {
			setConfig(config = {}) {
				this.$refs.form.set(config.data || {});
			},

			getConfig() {
				return new Promise(resolve => {
					this.$refs.form.validate({
						rule: {
							title: '请填写模块名称'
						},
						success: data => {
							resolve({
								type: 5,
								data
							});
						},
						fail: () => {
							resolve(false);
						}
					});
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		position: relative;
		border-radius: 6px;
		padding: 22px 26px 12px 16px;
		background: #F9F9F9;

		&:nth-child(n+2) {
			margin-top: 14px;
		}

		&-index {
			position: absolute;
			left: 0;
			top: 0;
			width: 18px;
			border-radius: 6px 0 6px 0;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #0081FA;
			background: #E0EDF9;
		}

		&-handle {
			position: absolute;
			right: 0;
			top: 0;

			a {
				width: 18px;
				height: 18px;
				border-radius: 0 6px 0 6px;
				font-size: 12px;
				color: #fff;
				background: #f55;
			}
		}

		&-add {
			&:nth-child(n+2) {
				margin-top: 14px;
			}
		}
	}

	.color-list {
		gap: 8px;
		padding: 2px 0;

		li {
			box-sizing: border-box;
			width: 34px;
			height: 34px;
			border: 1px solid #fff;
			border-radius: 100%;
			cursor: pointer;

			&:hover,
			&.z-crt {
				border-color: var(--color-main);
			}

			div {
				width: 22px;
				height: 22px;
				border: 1px solid #ddd;
				border-radius: 100%;
			}
		}
	}

	>>> .data-filter .filter li:nth-child(1):nth-last-child(1) {
		padding-top: 4px;
	}
</style>